export default {
  "home": {
    "listen": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Écoutez de la bonne musique!"])}
  },
  "register": {
    "TOS": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
    "accept": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
  },
  "song": {
    "comment_count": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])}
  }
}